/**
 * @flow
 * @relayHash 76abca6a93c955cee41432b6bb3728d5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateViewerAvatarInput = {|
  avatar?: ?string
|};
export type UpdateViewerAvatarMutationVariables = {|
  input?: ?UpdateViewerAvatarInput
|};
export type UpdateViewerAvatarMutationResponse = {|
  +updateViewerAvatar: {|
    +user: {|
      +id: string,
      +avatar: ?string,
    |}
  |}
|};
export type UpdateViewerAvatarMutation = {|
  variables: UpdateViewerAvatarMutationVariables,
  response: UpdateViewerAvatarMutationResponse,
|};
*/


/*
mutation UpdateViewerAvatarMutation(
  $input: UpdateViewerAvatarInput
) {
  updateViewerAvatar(input: $input) {
    user {
      id
      avatar
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateViewerAvatarInput",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateViewerAvatar",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateViewerAvatarPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "avatar",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateViewerAvatarMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateViewerAvatarMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateViewerAvatarMutation",
    "id": null,
    "text": "mutation UpdateViewerAvatarMutation(\n  $input: UpdateViewerAvatarInput\n) {\n  updateViewerAvatar(input: $input) {\n    user {\n      id\n      avatar\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fd6ab5eff86c3b73f9f066e34a2c5fc2';
module.exports = node;
